<template>
  <z-action-picker
      v-model="showModal"
      height="80vh"
      title="选择与对方纠纷的订单"
      subTitle="(最多3件)"
      @confirm="onConfirm"
      :btn-props="btnProps"
    >
    <z-tabs v-model="activeTab">
      <z-tab title="我买的">
        <z-list
          v-model="fetchBoughtLoading"
          :finished="isBoughtListEnd"
          @load="onBoughtLoad"
          v-if="!showStanceBuy"
        >
          <z-checkbox-group v-model="checkboxresult" :max="3" @exceed="onExceed">
            <div
              v-for="(item,index) in boughtList"
              :key="index"
              class="checkbox-wrap"
              >
              <z-checkbox :name="item.orderId">
                <OrderItem :item="item"></OrderItem>
              </z-checkbox>
            </div>
          </z-checkbox-group>
        </z-list>
        <z-stance v-if="showStanceBuy" :show-btn="false" :show-info="false" descText="没有买过对方的商品欧~" type="general"></z-stance>
      </z-tab>
      <z-tab title="我卖的">
        <z-list
          v-model="fetchSoldLoading"
          :finished="isSoldListEnd"
          @load="onSoldLoad"
          v-if="!showStanceSell"
        >
          <z-checkbox-group v-model="checkboxresult" :max="3" @exceed="onExceed">
            <div
              v-for="(item,index) in soldList"
              :key="index"
              class="checkbox-wrap"
              >
              <z-checkbox :name="item.orderId">
                <OrderItem :item="item"></OrderItem>
              </z-checkbox>
            </div>
          </z-checkbox-group>
        </z-list>
        <z-stance v-if="showStanceSell" :show-btn="false" :show-info="false" descText="对方没有买过商品欧~" type="general"></z-stance>
      </z-tab>
    </z-tabs>
    </z-action-picker>
</template>

<script>
import { getorderlist } from '@api/resourceApi'
import { List, ActionPicker, Checkbox, CheckboxGroup, Tabs, Tab, Stance } from '@zz-common/zz-ui';
import OrderItem from './OrderItem'
export default {
  name: 'OrderList',
  components: {
    'z-list': List,
    'z-action-picker': ActionPicker,
    'z-checkbox': Checkbox,
    'z-checkbox-group': CheckboxGroup,
    'z-tabs': Tabs,
    'z-tab': Tab,
    'z-stance': Stance,
    OrderItem
  },
  props: ['show'],
  inject: ['sharedData'],
  data() {
    return {
      activeTab: '0',
      checkboxresult: [],

      fetchBoughtLoading: false,
      fetchSoldLoading: false,

      isBoughtListEnd: false,
      isSoldListEnd: false,

      boughtList: [],
      soldList: [],

      curSoldPageNo: 1,
      curBoughtPageNo: 1
    }
  },
  computed: {
    showModal: {
      get() {
        return this.show
      },
      set(_val) {
        this.$emit('close')
      }
    },
    showStanceBuy() {
      return this.isBoughtListEnd && this.boughtList.length == 0
    },
    showStanceSell() {
      return this.isSoldListEnd && this.soldList.length == 0
    },
    btnProps() {
      if (this.checkboxresult.length > 0) return {}
      return {
        disabled: true
      }
    }
  },
  methods: {
    onExceed() {
      this.$toast('最多只能选择3个');
    },
    onBoughtLoad() {
      this.fetchBought()
    },
    onSoldLoad() {
      this.fetchSold()
    },
    onConfirm() {
      const data = []
      data.push(...this.boughtList.filter((item) => {
        return this.checkboxresult.includes(item.orderId)
      }))

      data.push(...this.soldList.filter((item) => {
        return this.checkboxresult.includes(item.orderId)
      }))

      this.$emit('select', data)
      this.$emit('close')
    },
    // 获取订单接口
    getListInfo(type) {
      return getorderlist({
        type,
        toUid: this.sharedData.toUid,
        pageNo: type === '2' ? this.curBoughtPageNo++ : this.curSoldPageNo++
      })
        .then((res) => {
          return res
        })
        .catch((err) => {
          console.error(err)
        })
    },
    fetchBought() {
      this.getListInfo('2').then((data = []) => {
        this.fetchBoughtLoading = false
        if (data && data.length === 0) {
          this.isBoughtListEnd = true
        }
        this.boughtList = this.boughtList.concat(data)
      })
    },
    fetchSold() {
      this.getListInfo('1').then((data = []) => {
        this.fetchSoldLoading = false
        if (data && data.length === 0) {
          this.isSoldListEnd = true
        }
        this.soldList = this.soldList.concat(data)
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import "index.less";
</style>